import appConstants from '../../../../../../appConstants';
import { DELIVERY_ACCESSORIALS, PICKUP_ACCESSORIALS } from '../../constants';

const LIFTGATE_REASON_REQUIRED = '* Liftgate reason is required';

export interface LiftgateReasonOption {
  value: string;
  label: string;
}

export interface AccessorialItem {
  name: string;
  isChecked: boolean;
}

export interface AppConfigWithLiftgate {
  enableLiftgateReasonForStopCompletion?: boolean;
}

export interface PickupEditInfo {
  accessorials: AccessorialItem[];
  liftgateReasonCode?: string;
}

export interface DeliveryEditInfo extends PickupEditInfo {
  deliveryStatus?: string;
}

export const getLiftgateReasonDetail = (
  liftgateReasonList: LiftgateReasonOption[] | null | undefined,
  selectedLiftgateReasonCode: string | null | undefined
): string | null => {
  if (!liftgateReasonList?.length || !selectedLiftgateReasonCode) {
    return null;
  }
  const liftgateReasonDetails = liftgateReasonList.find(
    (reason) => reason.value === selectedLiftgateReasonCode
  );
  return liftgateReasonDetails ? liftgateReasonDetails.label : null;
};

export const isLiftgateChecked = (
  accessorials: AccessorialItem[] | null | undefined,
  liftgateCode: string
): boolean => {
  if (!accessorials?.length) return false;
  return accessorials.find((ele) => ele.name === liftgateCode)?.isChecked ?? false;
};

export const isLiftgateReasonEnabled = (
  configJSON: AppConfigWithLiftgate | null | undefined
): boolean => configJSON?.enableLiftgateReasonForStopCompletion ?? false;

export const getPickupLiftgateReasonValidationError = (
  configJSON: AppConfigWithLiftgate | null | undefined,
  editInfo: PickupEditInfo,
  value: string | null | undefined
): string | null => {
  if (!isLiftgateReasonEnabled(configJSON)) return null;
  if (!isLiftgateChecked(editInfo.accessorials, PICKUP_ACCESSORIALS.LIFTGATE)) return null;
  return value ? null : LIFTGATE_REASON_REQUIRED;
};

export const getDeliveryLiftgateReasonValidationError = (
  configJSON: AppConfigWithLiftgate | null | undefined,
  editInfo: DeliveryEditInfo,
  value: string | null | undefined
): string | null => {
  if (!isLiftgateReasonEnabled(configJSON)) return null;
  if (!isLiftgateChecked(editInfo.accessorials, appConstants.ACCESSORIAL.LIFTGATE)) return null;
  if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN) return null;
  return value ? null : LIFTGATE_REASON_REQUIRED;
};

export { DELIVERY_ACCESSORIALS, PICKUP_ACCESSORIALS };
